import { render, staticRenderFns } from "./gri-dialog.vue?vue&type=template&id=391adc62&scoped=true"
import script from "./gri-dialog.vue?vue&type=script&lang=js"
export * from "./gri-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391adc62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('391adc62')) {
      api.createRecord('391adc62', component.options)
    } else {
      api.reload('391adc62', component.options)
    }
    module.hot.accept("./gri-dialog.vue?vue&type=template&id=391adc62&scoped=true", function () {
      api.rerender('391adc62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/material/material-master-data/gri-dialog.vue"
export default component.exports